import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-bt gfu-bt--caption _tc--lighter" }
const _hoisted_2 = {
  key: 0,
  class: "_tc--dark"
}
const _hoisted_3 = {
  key: 1,
  class: "_tc--dark"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
            shouldStopCounting: $options.shouldStopCounting,
            days: $options.days,
            hours: $options.hours,
            minutes: $options.minutes,
            seconds: $options.seconds
        })), () => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.Resources.Homepage.ProjectCardLaunchingInLabel), 1 /* TEXT */),
        (!$options.shouldStopCounting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString($options.days) + " ", 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-bt gfu-bt--caption _tc--lighter" }, "d", -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString($options.hours) + " ", 1 /* TEXT */),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "gfu-bt gfu-bt--caption _tc--lighter" }, "h", -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString($options.minutes) + " ", 1 /* TEXT */),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "gfu-bt gfu-bt--caption _tc--lighter" }, "m", -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString($options.seconds) + " ", 1 /* TEXT */),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "gfu-bt gfu-bt--caption _tc--lighter" }, "s", -1 /* CACHED */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.Resources.Homepage.ProjectCardLaunchedLabel), 1 /* TEXT */))
      ])
    ]),
    _: 3 /* FORWARDED */
  }))
}